import Asyncview from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from '@pixelunion/rimg-shopify';

export default class StaticCart {
  constructor(section) {
    this.el = section.el;
    this.$el = $(section.el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');
    this.headerTotalPrice = document.querySelector('.cart-amount-wrap');
    this.$quantityInputs = null;
    this.$removeItem = null;
    this.updateTimeout = null;

    this._updateItemQuantity = this._updateItemQuantity.bind(this);
    this._bindEvents = this._bindEvents.bind(this);
    this._unbindEvents = this._unbindEvents.bind(this);

    this._bindEvents();
  }

  _bindEvents() {
    this.$quantityInputs = $('[data-quantity-key]', this.$el);
    this.$removeItem = $('[data-remove]', this.$el);
    this.cartTable = this.el.querySelector('[data-cart-table]');
    this.cartDiscountContainer = this.el.querySelector('[data-cart-discount-container]');
    this.totalPrice = this.el.querySelector('[data-total-price]');

    this.$quantityInputs.each((i, el) => {
      $(el).on('input', (event) => this._updateItemQuantity(event));
    });

    this.$removeItem.each((i, el) => {
      $(el).on('click', (event) => this._updateItemQuantity(event));
    });
  }

  _unbindEvents() {
    this.$quantityInputs.each((i, el) => {
      $(el).off('input');
    });

    this.$removeItem.each((i, el) => {
      $(el).off('click');
    });

    this.$quantityInputs = null;
    this.$removeItem = null;
  }

  _updateItemQuantity(event) {
    event.preventDefault();

    let $quantityInput;
    let quantity;
    let lineItemKey;

    if (event.currentTarget.hasAttribute('data-remove')) {
      quantity = 0;
      lineItemKey = event.currentTarget.dataset.lineItem;
    } else {
      $quantityInput = $(event.currentTarget);
      quantity = $quantityInput.val();
      if (quantity == "") {
        return;
      }
      lineItemKey = $quantityInput.data('quantity-key');
    }

    // cancel any pending requests
    if (this.updateTimeout !== null) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      // Debounce to avoid firing requests while user is still entering number

      const thisTimeoutId = this.updateTimeout;
      window.Shopify.changeItem(lineItemKey, quantity, (cart) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout && this.updateTimeout !== thisTimeoutId) {
          return;
        }
        if (cart.item_count === 0) {
          // reload to show empty cart state
          window.location.reload();
          return;
        }
        this.updateCart(cart, thisTimeoutId);
      });
    }, 300);
  }

  updateCart(cart, timeoutId) {

    const cartCount = cart.item_count;

    // Swap the cart contents to update discount labels.
    Asyncview.load(
      '/cart',
      '_ajax',
    )
      .done(({ options, html }) => {
        // If another request is in progress, discard this update
        if (this.updateTimeout !== timeoutId) {
          return;
        }

        this._unbindEvents();

        // Inject new cart table contents
        const newTableContainer = document.createElement('div');
        newTableContainer.innerHTML = html.table;

        morphdom(
          this.cartTable,
          newTableContainer.querySelector('table'),
          {
            onBeforeElUpdated: (fromEl, toEl) => {
              // Skip images if src matches
              // - we don't want to reload lazy loaded images
              if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                return false;
              }
              return true;
            },
          },
        );

        rimg.watch(this.cartTable);

        // Inject new cart level discounts
        const newDiscountContainer = document.createElement('div');
        newDiscountContainer.innerHTML = html.discounts;
        this.cartDiscountContainer.innerHTML = newDiscountContainer.querySelector('[data-cart-discount-container]').innerHTML;

        // Update total
        this.totalPrice.innerHTML = options.totalPrice;
        this.headerTotalPrice.innerHTML = options.totalPrice;
        $('.cart-item-count-wrap').text(`(${options.itemCount})`);

        this._bindEvents();
      })
      .fail(() => window.location.reload());
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
